import { uniformDiscrete } from "./random";
const requestAnimationFrame =
  window.requestAnimationFrame || window.webkitRequestAnimationFrame || (fn => setTimeout(fn, 16));

/**
 * Create a default Render
 * @param  {Canvas} canvas canvas
 * @param  {Context} context context
 * @return {Function} handler
 */
function createRender(image: HTMLImageElement, canvas: any, context: any) {
  const zoomInStage: number = uniformDiscrete(89, 91) / 100;
  const zoomInRest: number = 1 - zoomInStage;
  const basicScale: number = (uniformDiscrete(45, 60) + uniformDiscrete(45, 60)) / 100;
  const getScale = (lifespan: number) => {
    if (lifespan > zoomInStage) {
      const gap: number = (1 - lifespan) / zoomInRest;
      return Math.max(Number(gap.toFixed(2)), 0.1) * basicScale;
    } else {
      return basicScale;
    }
  };

  const basicRotate = uniformDiscrete(-30, 30);
  const getRotate = (lifespan: any) => {
    return basicRotate;
  };

  const offset = 10;
  const basicTranslateX = canvas.width / 2 + uniformDiscrete(-offset, offset);
  const amplitude =
    (canvas.width - Math.sqrt(Math.pow(image.width, 2) + Math.pow(image.height, 2))) / 2 - offset;
  const wave = uniformDiscrete(amplitude * 0.8, amplitude) * (uniformDiscrete(0, 1) ? 1 : -1);
  const frequency = uniformDiscrete(250, 400);
  const getTranslateX = (lifespan: any) => {
    if (lifespan > zoomInStage) {
      return basicTranslateX;
    } else {
      return (
        basicTranslateX + wave * Math.sin((frequency * (zoomInStage - lifespan) * Math.PI) / 180)
      );
    }
  };

  const getTranslateY = (lifespan: number) => {
    return image.height / 2 + (canvas.height - image.height / 2) * lifespan;
  };

  const fadeOutStage: number = uniformDiscrete(14, 18) / 100;
  const getAlpha = (lifespan: number) => {
    if (lifespan > fadeOutStage) {
      return 1;
    } else {
      return 1 - Number(((fadeOutStage - lifespan) / fadeOutStage).toFixed(2));
    }
  };

  return (lifespan: number) => {
    if (lifespan >= 0) {
      context.save();
      const scale = getScale(lifespan);
      const rotate = getRotate(lifespan);
      const translateX = getTranslateX(lifespan);
      const translateY = getTranslateY(lifespan);
      context.translate(translateX, translateY);
      context.scale(scale, scale);
      context.rotate((rotate * Math.PI) / 180);
      context.globalAlpha = getAlpha(lifespan);
      context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
      context.restore();
      return;
    } else {
      return true;
    }
  };
}

class BubbleHearts {
  public canvas: HTMLCanvasElement;
  private context: CanvasRenderingContext2D;
  private children: any[];
  /**
   * Init a stage
   * @return {BubbleHearts} this
   */
  constructor() {
    const canvas = (this.canvas = document.createElement("canvas"));
    const context = (this.context = canvas.getContext("2d") as CanvasRenderingContext2D);
    const children = (this.children = []);
    const animate = () => {
      requestAnimationFrame(animate);
      context.clearRect(0, 0, canvas.width, canvas.height);
      let index = 0;
      let length = children.length;
      while (index < length) {
        const child: any = children[index];
        const nd: number = new Date().getTime();
        if (child.render.call(null, (child.timestamp + child.duration - nd) / child.duration)) {
          // pop it
          children.splice(index, 1);
          length--;
        } else {
          // continue
          index++;
        }
      }
    };
    requestAnimationFrame(animate);
  }

  /**
   * Create a bubble heart animation on stage
   * @param  {Image} image heart e.g.
   * @param  {Number} duration lifespan
   * @param  {Function} render handler
   * @return {BubbleHearts} this
   */
  public bubble(
    image: HTMLImageElement,
    duration = uniformDiscrete(2400, 3600),
    render = createRender(image, this.canvas, this.context)
  ) {
    this.children.push({
      duration,
      render,
      timestamp: +new Date()
    });
    return this;
  }
}

export default BubbleHearts;



// WEBPACK FOOTER //
// ./src/publics/assets/js/canvas-heart.ts